<template>
  <el-tooltip :disabled="!maxLength" effect="light" placement="top" :content="lengthLimit">
    <el-input
      :type="type || 'text'"
      :class="{ invalid: isInvalid }"
      :disabled="computedReadOnly"
      v-bind="$props"
      :aria-label="$i18n.t(title)"
      :placeholder="$i18n.t(placeholder)"
      @input="onInput"
      :maxlength="maxLength"
      :rows="rows"
      clearable
      @keyup.enter="handleEnterKey"
      @keyup.esc="handleEscapeKey"
    ></el-input>
  </el-tooltip>
</template>
<script>
/**
 * @class BaseInput
 *
 * @description This component renders a text input
 */
export default {
  name: 'base-input',
  props: [
    'name',
    'title',
    'value',
    'id',
    'type',
    'rows',
    'maxLength',
    'groupReadOnly',
    'readOnly',
    'formattedValue',
    'placeholder',
    'validationName',
    'isInvalid',
  ],
  methods: {
    onInput(value) {
      this.$emit('form-item-changed', { name: this.name, value: value })
      this.$emit('input', { name: this.name, value: value })
      this.removeError(value.target)
      this.$emit('user-overwrite', value !== '')
      if (this.validationName) {
        this.$validator.validate(this.validationName, value)
      }
    },
    // if more element needs this, can be refactored into a utils and included as a mixin.
    removeError(el) {
      if (el) {
        el.classList.remove('error')
      }
    },
    handleEnterKey() {
      this.$emit('keyup-enter')
    },
    handleEscapeKey() {
      this.$emit('keyup-escape')
    },
  },
  computed: {
    currentLength() {
      return this.value ? this.value.length : 0
    },
    lengthLimit() {
      return `${this.currentLength} / ${this.maxLength}`
    },
    computedReadOnly() {
      return !!(this.readOnly || this.groupReadOnly)
    },
  },
}
</script>
<style lang="scss" scoped>
[readonly] {
  background: $background-color-readonly !important;
  cursor: not-allowed !important;
}
</style>
